<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="main">
      <navMenu :active="active"></navMenu>
      <div class="content" v-loading.fullscreen.lock="loading">
        <div class="main-title">下载及其他</div>
        <div  v-if="detail.deadline" class="main-sub pd">提交截止日期：{{ detail.deadline }}</div>

       <el-form ref="form" label-width="100px" style="margin-top: 30px;">

          <el-form-item label="届数：">
              <el-select
             
                v-model="searchs.cid"
                filterable
                clearable
                placeholder="请选择届数"
              >
                <el-option
                  v-for="item in lists"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              <el-button size="medium" class="search"  type="primary" @click="changeSession">查询</el-button>
            </el-form-item>
          </el-form>
        <el-row type="flex">
          <el-col :sm="24" :md="24" :lg="24" :xl="24" class="template-div">
            <div ref="templateHeight">
              <div
                class="t_list"
                v-if="fileList.length>0"
              >
               <div class="template-list"   v-for="(item, index) in fileList"
               :key="index">
                <el-image
                  class="file-icon"
                  :src="fileIcon"
                  fit="cover"
                ></el-image>
                <div class="te-left">
                  <p class="file-name">{{ item.name }}</p>
                  <p class="file-time">上传时间：{{ item.create_time }}</p>
                  <!-- <p class="file-num">已下载 {{ item.downloadNum }} 次</p> -->
                </div>
                <div
                  class="te-right"
                  @click="down(item.url)"
                >
                  下载
                </div>
               </div>
              </div>
              <nodata  v-if="fileList.length==0"></nodata>
            </div>
          </el-col>
        </el-row>
        <div class="conf-btn flex">
          <!-- 可跳过需要验证 -->
          <template  v-if="detail.is_skip==1&&detail.is_verify==1">
             <div class="btn" @click="next('skip')">跳过</div>
             <div class="btn next_btn" @click="next('next')">下一步</div>
          </template>
           <!-- 可跳过无需验证 -->
          <template  v-if="detail.is_skip==1&&detail.is_verify==0">
            <div class="btn next_btn" @click="next('known')">完成</div>
          </template>
          <!-- 不可跳过需要验证 -->
          <template  v-if="detail.is_skip==0&&detail.is_verify==1">
              <div class="btn next_btn" @click="next('next')">下一步</div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getDetail,
  getResources,
  getNotice,
  download,
  getlistCate,
  skipOrReadStep
} from "@/api/api";
import top from "../components/top.vue"; //头部
import navMenu from "../components/navMenu.vue"; //左侧步骤条
import nodata from "../components/nodata.vue";//暂无数据
export default {
  components: { top, navMenu,nodata },
  name: "exhibitorManual",
  data() {
    return {
      loading: false,
      active: 2,
      content: {
        title_brief: "",
      },
      richHtml: "",
      downIcon: require("../assets/icon07.png"), // 打包下载的图标
      fileIcon: require("../assets/file_img.jpg"), // pdf的图标
      zipFile: {}, //打包下载数据
      fileList: [], //pdf数据
      height: "500",
      searchs:{cid:''},
      detail:{},
      lists:[]
    };
  },
  mounted() {
   
    this.getData();
  },
  watch: {

  },
  methods: {
    getData() {
      let stepMenuList = JSON.parse(localStorage.getItem("menu"));
      this.stepMenuList = stepMenuList;
      // this.id = this.$route.query.id;
      let title = this.$route.query.title;
      var index = stepMenuList.findIndex(function (item) {
        return item.link_url == "/exhibitorManual";
      });
      this.detail=stepMenuList[index]
      this.active = index;
      this.getlistCate()
   
    },
    // 获取下载及其他列表
    getSource(cid) {
      this.loading = true;
      getResources({ cid }).then((res) => {
          this.loading = false;
          console.log(res, "======获取资源");
          if (res.code == 1) {
            let { data } = res;
            this.fileList = data.lists;
            // this.zipFile = data.zipFile;
            setTimeout(() => {
              let height = this.$refs.templateHeight.offsetHeight;
              if (height > 500) {
                this.height = height;
              }
            }, 50);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 切换届次
    changeSession(){
      this.getSource(this.searchs.cid);  
    },
    // 获取下载分类
    getlistCate(){
      getlistCate({}).then((res) => {
          this.loading = false;
          console.log(res, "======获取资源");
          if (res.code == 1) {
            let { data } = res.data;
             this.lists=data.lists;
             this.searchs.cid=data.lists[0].id
             this.getSource(this.searchs.cid);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
               // 跳转下一步
               next(type) {
      if(type=='next'){//下一步
        if(this.detail.action==1||this.detail.action==4){
          this.toPath();
        }else{
          this.$message.warning("请完善信息!")
        }

      }else if(type=='skip'){//跳过
        this.skipOrReadStep(1)
      }else if(type=='known'){//已知悉
        this.skipOrReadStep(2)
      }
    },
    // 跳过或者已知悉
    skipOrReadStep(action){
      let data={
        type:JSON.parse(localStorage.getItem("userdata")).type,
        action,
        mark:this.detail.mark
      }
      skipOrReadStep(data).then(res=>{
        if(res.code==1){
          this.$message.success("操作成功")
          this.toPath()
        }else{
          this.$message.error(res.data.msg)
        }

      }).catch(err=>{
        console.log(err)
      })

    },
    toPath() {

        this.active = 0;
        this.$router.push({
            path:'/conference'
        })
      }, //修改进度状态
   
    // 下载pdf
    down(url) {
      window.open(url, '_blank');
      // console.log(file, name, id, '========')
      // const IFRAME = document.createElement("iframe");
      // IFRAME.style.display = "none";
      // IFRAME.style.height = 0;
      // IFRAME.src = this.$imgOssUrl + file;
      // //console.log(IFRAME.src, '====')
      // document.body.appendChild(IFRAME);
      // if (id) {
      //   let data = this.$qs.stringify({
      //     resources: {
      //       resourcesid: id,
      //       resourcesName: name,
      //     },
      //   });
      //   this.upDownload(data);
      // }
      // setTimeout(() => {
      //   IFRAME.remove();
      // }, 60 * 1000);
    },
    // 下载报道通知pdf
    downNotice() {
      this.loading = true;
      getNotice()
        .then((res) => {
          //console.log(res, "======下载报道通知pdf");
          if (res.status == 200) {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "报道通知.pdf");
            document.body.appendChild(link);
            link.click();
            this.loading = false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    upDownload(data) {
      download(data)
        .then((res) => {})
        .catch((err) => {
          console.log(err);
        });
    },
    // 查询
    onSubmit(){

    }
  },
};
</script>
<style lang="scss" scoped>
      .conf-btn {
        position: absolute;
        bottom: 60px;
        left: 50%;
        transform: translateX(-50%);
        .btn {
          min-width: 128px;
    height: 36px;
    cursor: pointer;
    margin: 0 10px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    line-height: 36px;
    text-align: center;
    background: #ffffff;
    border: 1px solid #CAD2DD;
    border-radius: 9px;
          &:hover {
            text-decoration: underline;
          }
        }
  .next_btn {
    color: #fff;
    background: linear-gradient( 90deg, #F27FC0 0%, #E40080 100%);
    border: none;
  }
}
/deep/ .el-form-item__label{
  font-size: 20px;
  font-weight: 600;
}

.search{
  bottom:initial !important;
  left: 40% !important;
}
.te-right{
  border: 1px solid #008DFF;
  color: #2690E6;
  text-align: center;
  padding: 6px 20px;
  box-sizing: border-box;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
}
.t_list{
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
.template-list{

}
.down-btn {
  cursor: pointer;
}
.rich-text {
  cursor: pointer;
  max-height: 500px;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    width: 0px;
    height: 0px;
  }
  // &::-webkit-scrollbar-track-piece {
  //   background-color: rgba(0, 0, 0, 0.1);
  //   -webkit-border-radius: 6px;
  // }
  // &::-webkit-scrollbar-thumb:vertical {
  //   height: 5px;
  //   background-color: rgba(125, 125, 125, 0.3);
  //   -webkit-border-radius: 6px;
  // }
  // &::-webkit-scrollbar-thumb:horizontal {
  //   width: 5px;
  //   background-color: rgba(125, 125, 125, 0.3);
  //   -webkit-border-radius: 6px;
  // }
}
.edit-content /deep/ img {
  max-width: 100%;
}
@media only screen and (max-width: 1280px) {
  .template-list {
    width: 100%;
    margin-right: 0 !important;
  }
}
@media only screen and (max-width: 767px) {
  .t_list{
    margin-top: 30px;
  }
  .content .el-button {
        position: initial !important;
        margin-top: 20px;
    }
  .content{
    padding: 30px 0 130px 0;
   
  }
  .template-list{
    width: 100%;
    margin:0 auto 20px;
    // margin: 0px 20px 20px 20px;
    height: initial !important;
    padding: 0px 30px 10px 31px;
  }
.file-time {
    font-size: 12px !important;
    margin-top: 2px !important;
}
 .file-num {
    margin-top: 2px !important;
 
}
.content .el-button{
  font-size: 15px !important;
}
  .file-name{
    font-size: 16px !important;
    line-height: 22px !important;
  }
  .t_list{
    padding-bottom: 0px;
  }
  .main-title{
    margin-left: 30px;
  }
  .main-sub{
    margin-left: 30px;
  }
  .template-main {
    // margin-top: 30px;
}

}
</style>
<style scoped>
.el-select{
  width: 30%;
}
@media only screen and (max-width: 767px) {
  .el-select{
    width: 90%;
  }
}
</style>